(() => {
  const DISMISS_KEY = 'grooby_bundle_promo_dismissed';
  const END_KEY = 'grooby_offer_end';

  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const init = (root) => {
    if (!root || root.dataset.groovyBundleReady === 'true') return;
    root.dataset.groovyBundleReady = 'true';

    const popup = root.querySelector('[data-groovy-bundle-popup]');
    const dock = root.querySelector('[data-groovy-bundle-dock]');
    const dialog = root.querySelector('.groovy-bundle-promo__dialog');
    if (!popup || !dock) return;

    const configuredEnd = Date.parse(root.dataset.endAt || '');
    let endAt = configuredEnd;
    if (!Number.isFinite(endAt)) {
      const hours = Math.max(1, Number(root.dataset.fallbackHours || 48));
      let stored = 0;
      try {
        stored = Number(localStorage.getItem(END_KEY) || 0);
      } catch (_) {}
      if (!Number.isFinite(stored) || stored <= 0) {
        stored = Date.now() + hours * 60 * 60 * 1000;
        try {
          localStorage.setItem(END_KEY, String(stored));
        } catch (_) {}
      }
      endAt = stored;
    }

    const renderTime = (remaining) => {
      const totalSeconds = Math.floor(remaining / 1000);
      const parts = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
      };
      Object.entries(parts).forEach(([key, value]) => {
        root.querySelectorAll(`[data-groovy-bundle-${key}]`).forEach((node) => {
          node.textContent = pad(value);
        });
      });
    };

    const hideAll = () => {
      popup.hidden = true;
      dock.hidden = true;
      root.hidden = true;
      document.body.classList.remove('overflow-hidden');
      if (root._groobyBundleTimer) window.clearInterval(root._groobyBundleTimer);
    };

    const tick = () => {
      const remaining = endAt - Date.now();
      if (remaining <= 0) {
        hideAll();
        return;
      }
      renderTime(remaining);
    };

    const forceOpen = new URLSearchParams(window.location.search).has('grooby-promo');
    if (forceOpen) {
      try {
        sessionStorage.removeItem(DISMISS_KEY);
      } catch (_) {}
    }
    let dismissed = false;
    try {
      dismissed = sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (_) {}
    if (forceOpen || (window.Shopify && Shopify.designMode)) dismissed = false;

    const showPopup = () => {
      root.hidden = false;
      dock.hidden = true;
      popup.hidden = false;
      document.body.classList.add('overflow-hidden');
      root.querySelector('.groovy-bundle-promo__close')?.focus();
    };

    const showDock = () => {
      root.hidden = false;
      popup.hidden = true;
      dock.hidden = false;
      document.body.classList.remove('overflow-hidden');
    };

    const dismiss = () => {
      try {
        sessionStorage.setItem(DISMISS_KEY, '1');
      } catch (_) {}
      showDock();
    };

    root.querySelectorAll('[data-groovy-bundle-close]').forEach((node) => {
      node.addEventListener('click', dismiss);
    });
    root.querySelector('[data-groovy-bundle-cta]')?.addEventListener('click', () => {
      try {
        sessionStorage.setItem(DISMISS_KEY, '1');
      } catch (_) {}
      document.body.classList.remove('overflow-hidden');
    });

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        dismiss();
        return;
      }
      if (event.key !== 'Tab' || !dialog) return;
      const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled])')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    tick();
    if (endAt <= Date.now()) return;
    root._groobyBundleTimer = window.setInterval(tick, 1000);

    if (dismissed) showDock();
    else window.setTimeout(showPopup, 700);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-groovy-bundle-promo]')) init(scope);
    scope.querySelectorAll?.('[data-groovy-bundle-promo]').forEach(init);
  };

  initAll();
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.('[data-groovy-bundle-promo]').forEach((root) => {
      if (root._groobyBundleTimer) window.clearInterval(root._groobyBundleTimer);
    });
  });
})();
